import { DeviceTypeWithAndroidIOS } from '@/types/configs'
import { DeviceValue, SortValue } from '@/types/search'
import { SearchSort } from '@/types/store'

export const SEARCH_PAGE_LIMIT = 20

export const SEARCH_TOP_CREATORS_LIMIT = 2

export const SEARCH_TOP_WORLDS_LIMIT = 3

export const SEARCH_RECOMMENDED_LIMIT = 6

export const SEARCH_PARAM_KEYS = {
  KEYWORD: 'keyword',
  GENRE: 'genre',
  SORT: 'sort',
  DEVICE: 'device',
  TAB: 'tab',
  TYPE: 'type',
} as const

export const SORT_MAP: Record<SortValue, SearchSort> = {
  'release-date': 'first_public_date',
  // 👾 equivalent to original user world sort 'featured'
  recommended: 'recommend',
  latest: 'create_date',
  liked: 'most_liked',
  popular: 'most_viewed',
  // Saved-rooms enum — keys map to themselves since they already match the backend.
  // 'saved_date' is only valid against `/me/saved-worlds`; outside that endpoint it
  // falls back to `create_date` semantics.
  saved_date: 'create_date',
  most_viewed: 'most_viewed',
  most_liked: 'most_liked',
  create_date: 'create_date',
  first_public_date: 'first_public_date',
  last_updated_at: 'last_updated_at',
} as const

export const DEVICE_MAP: Record<DeviceValue, DeviceTypeWithAndroidIOS> = {
  desktop: 'desktop',
  vr: 'hmd',
  ios: 'ios',
  android: 'android',
} as const

export const VALID_SORT_VALUES: SortValue[] = Object.keys(SORT_MAP) as SortValue[]
export const VALID_API_SORTS: SearchSort[] = Object.values(SORT_MAP)
export const VALID_DEVICES: DeviceValue[] = Object.keys(DEVICE_MAP) as DeviceValue[]
